interface FeaturedSponsorshipProps {
  onCTAClick: () => void;
}

export default function FeaturedSponsorship({ onCTAClick }: FeaturedSponsorshipProps) {
  return (
    <section className="py-16 md:py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="bg-gradient-to-br from-yellow-400 via-yellow-500 to-yellow-600 rounded-3xl overflow-hidden shadow-2xl">
          <div className="flex flex-col md:grid md:grid-cols-2 gap-0">
            <div className="p-6 sm:p-10 md:p-16 flex flex-col justify-center">
              <div className="inline-block px-4 py-2 bg-purple-900 text-yellow-400 text-xs font-black uppercase tracking-wider rounded-full mb-4 w-fit">
                Most Visible Opportunity
              </div>

              <h2 className="text-4xl sm:text-5xl md:text-6xl font-black text-purple-900 mb-4 leading-tight">
                Helmet Sponsor
              </h2>

              <div className="flex flex-wrap items-end gap-4 mb-2">
                <div className="text-5xl md:text-6xl font-black text-purple-900">
                  $4,000
                </div>
                <div className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-purple-900 text-yellow-400 text-sm font-black rounded-full mb-2 whitespace-nowrap">
                  <i className="ri-calendar-2-line text-base"></i>
                  2-Year Sponsorship
                </div>
              </div>

              <p className="text-base md:text-lg text-purple-900 font-bold mb-5 opacity-80">
                $2,000/year — Your logo on helmets for <strong>two full seasons</strong>
              </p>

              <div className="space-y-3 mb-6">
                <div className="flex items-start gap-3">
                  <div className="w-7 h-7 flex items-center justify-center flex-shrink-0 bg-purple-900 rounded-full mt-0.5">
                    <i className="ri-check-line text-base text-yellow-400"></i>
                  </div>
                  <p className="text-base md:text-lg text-purple-900 font-medium">
                    Your logo appears on <strong>every player helmet</strong> for one CYFA team
                  </p>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-7 h-7 flex items-center justify-center flex-shrink-0 bg-purple-900 rounded-full mt-0.5">
                    <i className="ri-check-line text-base text-yellow-400"></i>
                  </div>
                  <p className="text-base md:text-lg text-purple-900 font-medium">
                    Visible at <strong>every practice and game</strong> across <strong>2 full seasons</strong>
                  </p>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-7 h-7 flex items-center justify-center flex-shrink-0 bg-purple-900 rounded-full mt-0.5">
                    <i className="ri-check-line text-base text-yellow-400"></i>
                  </div>
                  <p className="text-base md:text-lg text-purple-900 font-medium">
                    Featured in <strong>photos and social media</strong> all season long
                  </p>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-7 h-7 flex items-center justify-center flex-shrink-0 bg-purple-900 rounded-full mt-0.5">
                    <i className="ri-check-line text-base text-yellow-400"></i>
                  </div>
                  <p className="text-base md:text-lg text-purple-900 font-medium">
                    <strong>2 years</strong> of brand exposure for the price of one commitment
                  </p>
                </div>
              </div>

              <div className="bg-purple-900 text-yellow-400 p-4 rounded-xl mb-6">
                <p className="text-sm font-bold flex items-start gap-2">
                  <i className="ri-alarm-warning-line text-xl flex-shrink-0 mt-0.5"></i>
                  <span>Helmet sponsorships are limited to the number of teams each season</span>
                </p>
              </div>

              <button
                onClick={onCTAClick}
                className="px-8 py-4 bg-purple-900 hover:bg-purple-800 text-yellow-400 text-base md:text-xl font-black rounded-xl transition-all duration-300 hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer w-full"
              >
                Reserve Helmet Sponsorship
              </button>
            </div>

            <div className="relative bg-purple-900 p-8 md:p-12 flex items-center justify-center min-h-[260px] md:min-h-0">
              <div className="relative w-full flex flex-col gap-4 items-center justify-center h-full">
                <div className="w-full h-64 sm:h-80 md:h-72">
                  <img
                    src="https://static.readdy.ai/image/68c02a6c7db1e4f446ae7031426f220f/e8aadcf90217a819e3322d4d47599beb.png"
                    alt="Helmet Sponsorship Photo"
                    className="w-full h-full object-contain"
                  />
                </div>
                <div className="w-full h-64 sm:h-80 md:h-72">
                  <img
                    src="https://static.readdy.ai/image/68c02a6c7db1e4f446ae7031426f220f/640f4471a5d374c03f8d7bd4b5688aeb.png"
                    alt="Helmet Sponsorship Mockup"
                    className="w-full h-full object-contain"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}